/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import { useState } from "react";
import {Link} from "react-router-dom";
import {ACCESS_TOKEN_KEY} from "../../../utilities/Constants";
import {decodeToken} from "../../../utilities/auth/Introspect";

const NavigationBar = () => {
  const [tagsDropdown, setTagsDropdown] = useState(false);
  const [partsDropdown, setPartsDropdown] = useState(false);
  const [printersDropdown, setPrintersDropdown] = useState(false);
  const [effectivityDropdown, setEffectivityDropdown] = useState(false);

    const toggleTagsDropdown = () => {
        setTagsDropdown(!tagsDropdown);
    };

    const togglePartsDropdown = () => {
        setPartsDropdown(!partsDropdown);
    };

    const togglePrintersDropdown = () => {
        setPrintersDropdown(!printersDropdown);
    };

    const toggleEffectivityDropdown = () => {
        setEffectivityDropdown(!effectivityDropdown);
    };

    const hideDropdowns = () => {
        setTagsDropdown(false);
        setPartsDropdown(false);
        setPrintersDropdown(false);
        setEffectivityDropdown(false);
    };

  const userLogout = async () => {
      window.location.href = "/#/not-authorized";
      await sessionStorage.clear();
      await caches.keys().then((names) => {
          names.forEach((name) => {
              caches.delete(name);
          });
      });
      window.location.href = process.env.REACT_APP_LOGOUT_URI;
  };

    const role = decodeToken(JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY)));
    const admin = role.admin;
    const user = role.user;

    return (
        <nav>
            <ul className="menu">
                <li
                    className="menu-items"
                    onClick={toggleTagsDropdown}
                    onMouseLeave={hideDropdowns}
                >
                    <button type="menu-button">
                        Tags{" "}<span className="arrow"/>
                    </button>
                    <div className={`dropdown-items ${tagsDropdown ? "show" : ""}`}>
                        <ul>
                            <li className={`dropdown-button ${admin || user ? "show" : ""}`}>
                                <Link to="create-tag">Create Tag</Link>
                            </li>
                            <li className={`dropdown-button ${admin || user ? "show" : ""}`}>
                                <Link to="tag-list">Tag List/Search</Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li
                    className="menu-items"
                    onClick={togglePartsDropdown}
                    onMouseLeave={hideDropdowns}
                >
                    <button type="menu-button">
                        Parts{" "}<span className="arrow"/>
                    </button>
                    <div className={`dropdown-items ${partsDropdown ? "show" : ""}`}>
                        <ul>
                            <li className={`dropdown-button ${admin ? "show" : ""}`}>
                                <Link to="create-part">Create Part</Link>
                            </li>
                            <li className={`dropdown-button ${admin || user ? "show" : ""}`}>
                                <Link to="part-list">Part List</Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li
                    className="menu-items"
                    onClick={togglePrintersDropdown}
                    onMouseLeave={hideDropdowns}
                >
                    <button type="menu-button">
                        Printers{" "}<span className="arrow"/>
                    </button>
                    <div className={`dropdown-items ${printersDropdown ? "show" : ""}`}>
                        <ul>
                            <li className={`dropdown-button ${admin ? "show" : ""}`}>
                                <Link to="create-printer">Create Printer</Link>
                            </li>
                            <li className={`dropdown-button ${admin || user ? "show" : ""}`}>
                                <Link to="printer-list">Printer List</Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li
                    className="menu-items"
                    onClick={toggleEffectivityDropdown}
                    onMouseLeave={hideDropdowns}
                >
                    <button type="menu-button">
                        Effectivity{" "}<span className="arrow"/>
                    </button>
                    <div
                        className={`dropdown-items ${effectivityDropdown ? "show" : ""}`}
                    >
                        <ul>
                            <li className={`dropdown-button ${admin ? "show" : ""}`}>
                                <Link to="create-effectivity">Create Effectivity</Link>
                            </li>
                            <li className={`dropdown-button ${admin || user ? "show" : ""}`}>
                                <Link to="effectivity-list">Effectivity List</Link>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="menu-items">
                    <button type="menu-button" onClick={userLogout}>
                        Logout
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default NavigationBar;